import Fade from '@mui/material/Fade';

const Backdrop = ({className, isHamburgerOpen, isModalOpen, setIsModalOpen}) => (
  <Fade in={isHamburgerOpen || isModalOpen} timeout={500}>
    <div className={className} />
  </Fade>
);

export default Backdrop;